export const COORDS = {
  // Coordinate ricalibrate sul nuovo template modellou.pdf (rev. 16/07/2026).
  // Margine destro del documento = x 545 (i campi allineati a destra terminano lì).
  agenziaData: { x: 545, y: 734 },  // SEDE, DATA - sopra "Gent.mo/a," (right align)
  nominativo:  { x: 545, y: 670 },  // una riga sotto label NOMINATIVO/RAG. SOCIALE (y label 689) (right align)
  cf_piva:     { x: 545, y: 632 },  // una riga sotto label CODICE FISCALE/P. IVA (y label 649) (right align)
  targa:       { x: 371, y: 539 },  // accanto alla parola "Targata" (che finisce ~x373, baseline 538.9) (left align)
  pacchetto:   { x: 195, y: 485 },  // accanto/sotto label PACCHETTO GARANTITO (y label 484.5) (left align)
};
